import { AnySelection } from '@d3fc/d3fc-series';
import { AnyChart } from '@d3fc/d3fc-chart';
import { select } from 'd3-selection';

export function autoSizeYAxis(
    chart: AnyChart,
    node: HTMLDivElement,
    yDecorate?: (selection: AnySelection<SVGElement>) => void
) {
    chart.yDecorate((selection: AnySelection<SVGElement>) => {
        yDecorate && yDecorate(selection);

        const textSelection: AnySelection<SVGTextElement> =
            selection.select('text');
        const widths = measureTextNodes(textSelection);
        const maxWidth = Math.max(...widths) + 2;

        const maxWidthStyle = `${maxWidth}px`;

        select(node).select('.y-axis').style('width', maxWidthStyle);

        select(node)
            .select('.y-axis svg')
            .call((svgSel) => {
                const yAxisSvg = svgSel.nodes()[0] as unknown as {
                    viewBox: SVGAnimatedRect;
                };
                if (yAxisSvg?.viewBox?.baseVal) {
                    yAxisSvg.viewBox.baseVal.x = maxWidth * -1;
                    yAxisSvg.viewBox.baseVal.width = maxWidth;
                }
            });

        select(node)
            .select('.plot-area > svg')
            .call((svgSel) => {
                const plotAreaSvg = svgSel.nodes()[0] as unknown as {
                    viewBox: SVGAnimatedRect;
                    clientWidth: number;
                };
                if (plotAreaSvg?.viewBox?.baseVal) {
                    plotAreaSvg.viewBox.baseVal.width = plotAreaSvg.clientWidth;
                }
            });

        select(node)
            .select('.x-axis svg')
            .call((svgSel) => {
                const plotAreaSvg = svgSel.nodes()[0] as unknown as {
                    viewBox: SVGAnimatedRect;
                    clientWidth: number;
                };
                if (plotAreaSvg?.viewBox?.baseVal) {
                    plotAreaSvg.viewBox.baseVal.width = plotAreaSvg.clientWidth;
                }
            });
    });
}

function measureTextNodes(
    textSelection: AnySelection<SVGTextElement>
): Array<number> {
    return textSelection.nodes().map((n: SVGTextElement) => n.getBBox().width);
}
